import axios from 'axios';
import React from 'react';
import { navigate } from '@reach/router';
import { useTranslation } from 'react-i18next';

import MainWrapper from '../Utils/MainWrapper';
import { purgeLocalData } from '../../../proto/utils/updates';
import styles from './ResetPage.module.css';

function ActionLink() {
  const { t } = useTranslation();

  async function purgeUser() {
    const response = await axios({
      method: 'delete',
      url: new URL('/ui_backend/proxy/sync/api/sync/purge_user_data/', process.env.REACT_APP_PROXY_HOST),
      withCredentials: true,
    });
    if (response.status === 200) {
      await purgeLocalData(true);
    }
    navigate(process.env.REACT_APP_BASE_PATH);
  }

  return (
    <MainWrapper caption={t('Reset Passphrase')}>
      <div className={styles.resetText}>
        {t('All your data (passwords, open tabs, bookmarks, browsing history etc.) will remain saved on your devices. However, they will be removed from the server so you will have to synchronise them again.')}
      </div>
      <button onClick={purgeUser} type="button" className={styles.resetButton}>
        {t('Reset Passphrase')}
      </button>
    </MainWrapper>
  );
}

function ResetPage() {
  return (
    <main className={styles.page}>
      <ActionLink />
    </main>
  );
}

export default ResetPage;
